export default "__VITE_ASSET__KXjfPpbC__"